type SuccessCallback = (values: unknown, followUpUrl: string) => boolean | void;

export const createDryRunMarketoForm = () => {
  const successCallbacks: SuccessCallback[] = [];

  const form = {
    vals: () => {
      return form;
    },
    validate: () => {
      return true;
    },
    submit: () => {
      queueMicrotask(() => {
        successCallbacks.forEach((callback) => {
          callback({}, '');
        });
      });
      return form;
    },
    onSuccess: (callback: SuccessCallback) => {
      successCallbacks.push(callback);
      return form;
    },
  };

  return form;
};
